import React from 'react'
import {
  Label
} from 'react-bootstrap'
import KanBoIcon from 'components/KanBoIcon'
import classes from './Tag.module.scss'
import { useColor } from 'utils/colors'

const Tag: React.FC<{
  name: string;
  color: number;
  small?: boolean;
  inline?: boolean;
  selected?: boolean;
  className?: string;
  onClick?: (...args: any[]) => void;
}> = ({ name, color, small, inline, selected, className, onClick, ...props }) => {
  let compClassName = classes.tag
  if (small) {
    compClassName += ' ' + classes.small
  }
  if (inline) {
    compClassName += ' ' + classes.inline
  }
  if (onClick) compClassName += ' ' + classes.hover
  if (className) compClassName += ' ' + className

  const tagColor = useColor(color)

  return (
    <Label
      {...props}
      className={compClassName}
      style={{ color: tagColor }}
      onClick={onClick}
    >
      {(typeof selected === 'boolean') &&
        <span className={classes.selectedIcon}>
          {selected &&
            <KanBoIcon fixedWidth name='kanbo-16-tasks' />
          }
          {!selected &&
            <KanBoIcon fixedWidth />
          }
        </span>
      }
      {name}
    </Label>
  )
}

export default Tag

